/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import React from "react";
import api from "../../utils/api";
import { Link, useParams, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import Select from "react-select";
import { MagnifyingGlass, Plus, FunnelSimple, CheckCircle, ArrowLeft } from "@phosphor-icons/react";
import { Eye, Download, Users, ChartBar, Clock, ChevronRight, Filter } from "lucide-react";

const ChapterList = () => {
  const [chapters, setChapters] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const { id } = useParams();
  
  const navigate = useNavigate();
  const [userPermissions, setUserPermissions] = useState({});
  const [loading, setLoading] = useState(false);
  const [selectedSubjects, setSelectedSubjects] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [templateSubjectIds, setTemplateSubjectIds] = useState([]);
  const [allSelected, setAllSelected] = useState(false);
  const [dataLoading, setDataLoading] = useState(false);

  const subjectOptions = subjects.map((subject) => ({
    value: subject.id,
    label: `${subject.subjectName} (${subject.subjectCount})`,
  }));

  useEffect(() => {
    auth();
    const fetchAll = async () => {
      const subjectIds = await fetchTemplateDetails();
      await fetchSubjects(subjectIds);
    };
    fetchAll();
  }, []);

  async function auth() {
    setLoading(true);
    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const role = localStorage.getItem("role");
      const token = localStorage.getItem("authToken");

      const fd = new FormData();
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("role", role);
      fd.append("programType", "getPagePermission");
      fd.append("pageNo", 7);

      const response = await api.post("user/userCurl", fd);
      if (response.data?.data?.length > 0) {
        setUserPermissions(response.data.data[0]);
      }
    } catch (error) {
      console.error("Error fetching permissions:", error);
      toast.error("Error fetching permissions.");
    } finally {
      setLoading(false);
    }
  }

  async function fetchTemplateDetails() {
    const loggedInUser = localStorage.getItem("loggedInUser");
    const token = localStorage.getItem("authToken");
  
    const fd = new FormData();
    fd.append("programType", "getTemplateDetailsInAddQuestions");
    fd.append("loggedInUser", loggedInUser);
    fd.append("token", token);
    fd.append("id", id);
  
    try {
      const response = await api.post("paper/paperCurl", fd);
      console.log("Template details response:", response);  
      const templateDetails = response.data?.data?.[0]?.details;
  
      if (templateDetails) {
        const parsed = JSON.parse(templateDetails);
        const sections = parsed.sections;
  
        const subjectIdSet = new Set();
        Object.values(sections).forEach((section) => {
          Object.values(section.subjects).forEach((subj) => {
            subjectIdSet.add(Number(subj.subjectId));
          });
        });
  
        const ids = Array.from(subjectIdSet);
        setTemplateSubjectIds(ids);
        return ids;
      }
    } catch (error) {
      console.error("Error fetching template details:", error);
    }
    return [];
  }

  async function fetchSubjects(templateSubjectIds = []) {
    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const role = localStorage.getItem("role");
      const token = localStorage.getItem("authToken");
  
      const fd = new FormData();
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("programType", "getSubjectOnChange");
      fd.append("role", role);
  
      const subjectResponse = await api.post("onchange/onchangeCurl", fd);
      console.log("Subjects response:", subjectResponse);
      const fetchedSubjects = Array.isArray(subjectResponse.data.data)
        ? subjectResponse.data.data
        : [];

      const filteredSubjects = fetchedSubjects.filter((subject) =>
        templateSubjectIds.includes(Number(subject.id))
      );
  
      setSubjects(filteredSubjects);
  
      const storedSubjectIds = JSON.parse(localStorage.getItem("selectedSubjects")) || [];
      setSelectedSubjects(storedSubjectIds);
  
      if (storedSubjectIds.length > 0) {
        setTimeout(fetchChapters, 0);
      }
    } catch (error) {
      console.error("Error fetching subjects:", error);
      setSubjects([]);
    }
  }

  const customSelectStyles = {
    control: (provided, state) => ({
      ...provided,
      minHeight: "42px",
      height: "auto",
      borderRadius: "10px",
      border: state.isFocused ? "1px solid #3E80F9" : "1px solid #e2e8f0",
      backgroundColor: "#fff",
      boxShadow: state.isFocused ? "0 0 0 3px rgba(62, 128, 249, 0.1)" : "0 1px 2px rgba(0,0,0,0.05)",
      transition: "all 0.2s",
      "&:hover": {
        borderColor: "#94a3b8"
      }
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: "4px 12px",
      flexWrap: "wrap",
    }),
    multiValue: (provided) => ({
      ...provided,
      backgroundColor: "#eff6ff",
      borderRadius: "6px",
      padding: "2px 6px",
      margin: "4px",
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      color: "#1d4ed8",
      fontSize: "13px",
      fontWeight: "500",
    }),
    multiValueRemove: (provided) => ({
      ...provided,
      color: "#93c5fd",
      "&:hover": {
        backgroundColor: "#dbeafe",
        color: "#1d4ed8",
      },
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      height: "40px",
    }),
    menu: (provided) => ({
      ...provided,
      borderRadius: "10px",
      boxShadow: "0 10px 25px rgba(0,0,0,0.1)",
      zIndex: 9999,
    }),
    menuPortal: base => ({ ...base, zIndex: 9999 }),
  };

  async function fetchChapters() {
    setIsLoading(true);
    setDataLoading(true);
    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const token = localStorage.getItem("authToken");

      const fd = new FormData();
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("programType", "getChapterOnChangeMultiple");
      fd.append("paperId", id);

      selectedSubjects.forEach((subjectId) => {
        fd.append("subjectId[]", subjectId);
      });

      const response = await api.post("onchange/onchangeCurl", fd);

      if (response.data && Array.isArray(response.data.data)) {
        const storedChapterIds = JSON.parse(localStorage.getItem("selectedChapters")) || [];
        
        const updatedChapters = response.data.data.map((chapter, index) => ({
          ...chapter,
          id: chapter.id,
          selected: storedChapterIds.includes(String(chapter.id)),
          serial: index + 1
        }));

        setChapters(updatedChapters);
        
        // Check if all filtered chapters are selected
        const allChaptersSelected = updatedChapters.length > 0 && 
          updatedChapters.every(ch => ch.selected);
        setAllSelected(allChaptersSelected);
      } else {
        setChapters([]);
        setAllSelected(false);
      }
    } catch (error) {
      console.error("Error fetching chapters:", error);
      setChapters([]);
      setAllSelected(false);
    } finally {
      setIsLoading(false);
      setDataLoading(false);
    }
  }

  const filteredChapters = chapters.filter(
    (chapter) =>
      chapter.chapterName.toLowerCase().includes(searchTerm.toLowerCase()) ||
      String(chapter.id).includes(searchTerm)
  );

  const handleChapterChange = (chapterId) => {
    const updatedChapters = chapters.map(chapter => 
      chapter.id === chapterId 
        ? { ...chapter, selected: !chapter.selected }
        : chapter
    );
    
    setChapters(updatedChapters);
    
    // Update allSelected state
    const allSelectedNow = updatedChapters.length > 0 && 
      updatedChapters.every(ch => ch.selected);
    setAllSelected(allSelectedNow);
  };

  const handleSelectAll = () => {
    const newSelectionState = !allSelected;
    const updatedChapters = chapters.map(chapter => ({
      ...chapter,
      selected: newSelectionState
    }));
    
    setChapters(updatedChapters);
    setAllSelected(newSelectionState);
  };

  async function handleSubmit() {
    const loggedInUser = localStorage.getItem("loggedInUser");
    const token = localStorage.getItem("authToken");

    const selectedChapterIds = chapters
      .filter((chapter) => chapter.selected)
      .map((chapter) => chapter.id);

    localStorage.setItem("selectedChapters", JSON.stringify(selectedChapterIds));
    localStorage.setItem("selectedSubjects", JSON.stringify(selectedSubjects));

    const fd = new FormData();
    fd.append("paperId", id);
    fd.append("chapterId", selectedChapterIds.join(","));
    fd.append("programType", "addChapterToPaper");
    fd.append("loggedInUser", loggedInUser);
    fd.append("token", token);

    try {
      const response = await api.post("/picQuestion/picQuestionCurl", fd);
      toast.success("Chapters added successfully!");
      navigate(`/pick-questions/${id}`);
    } catch (error) {
      console.error("Error submitting chapters:", error);
      toast.error("Failed to submit chapters");
    }
  }

  const TableLoader = () => (
    <tbody>
      {Array.from({ length: 5 }).map((_, index) => (
        <tr key={index}>
          <td style={{ padding: "16px", textAlign: "center" }}>
            <div style={{
              height: "20px",
              backgroundColor: "#f0f0f0",
              borderRadius: "4px",
              animation: "pulse 1.5s infinite"
            }}></div>
          </td>
          <td style={{ padding: "16px" }}>
            <div style={{
              height: "20px",
              backgroundColor: "#f0f0f0",
              borderRadius: "4px",
              animation: "pulse 1.5s infinite"
            }}></div>
          </td>
          <td style={{ padding: "16px", textAlign: "center" }}>
            <div style={{
              height: "20px",
              width: "20px",
              backgroundColor: "#f0f0f0",
              borderRadius: "4px",
              animation: "pulse 1.5s infinite",
              margin: "0 auto"
            }}></div>
          </td>
        </tr>
      ))}
    </tbody>
  );

  return (
    <div style={{
      minHeight: "100vh",
      background: "#f8fafc",
      padding: "24px",
      fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif"
    }}>
      {userPermissions.is_view === "0" ? (
        <div style={{
          background: "#fef2f2",
          border: "1px solid #fecaca",
          borderRadius: "10px",
          padding: "40px 20px",
          textAlign: "center",
          marginTop: "50px"
        }}>
          <div style={{ fontSize: "36px", marginBottom: "16px", color: "#dc2626" }}>
            ⚠️
          </div>
          <h4 style={{ color: "#dc2626", marginBottom: "8px" }}>Permission Denied</h4>
          <p style={{ color: "#7f1d1d", fontSize: "14px" }}>
            You don't have permission to access this page.
          </p>
        </div>
      ) : (
        <>
          <ToastContainer position="top-right" autoClose={3000} />

          {/* Header Section */}
          <div style={{ marginBottom: "32px" }}>
           
            <div style={{
              background: "#fff",
              borderRadius: "12px",
              padding: "24px",
              marginTop: "24px",
              boxShadow: "0 1px 3px rgba(0,0,0,0.08)"
            }}>
              <div style={{display:"flex", justifyContent:"space-between", width:"100%"}}>
              <h3 style={{
                fontSize: "16px",
                fontWeight: "600",
                color: "#334155",
                marginBottom: "16px",
                display: "flex",
                alignItems: "center",
                gap: "8px"
              }}>
                <FunnelSimple size={20} />
                Filter Subjects
              </h3>

              
                <button
                  onClick={fetchChapters}
                  disabled={selectedSubjects.length === 0}
                  style={{
                    background: selectedSubjects.length === 0 
                      ? "#e2e8f0" 
                      : "linear-gradient(135deg, #3E80F9 0%, #2d5bff 100%)",
                    color: selectedSubjects.length === 0 ? "#94a3b8" : "#fff",
                    border: "none",
                    padding: "12px 28px",
                    borderRadius: "10px",
                    fontSize: "14px",
                    fontWeight: "600",
                    cursor: selectedSubjects.length === 0 ? "not-allowed" : "pointer",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    transition: "all 0.3s",
                    boxShadow: selectedSubjects.length === 0 ? "none" : "0 2px 8px rgba(62, 128, 249, 0.3)"
                  }}
                  onMouseEnter={(e) => {
                    if (selectedSubjects.length > 0) {
                      e.target.style.transform = "translateY(-2px)";
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (selectedSubjects.length > 0) {
                      e.target.style.transform = "translateY(0)";
                    }
                  }}
                >
                  <MagnifyingGlass size={18} weight="bold" />
                  Fetch Chapters
                </button>
            
              </div>
              <div style={{ marginBottom: "20px" }}>
                <div style={{ marginBottom: "8px", fontSize: "14px", color: "#475569", fontWeight: "500" }}>
                  Select Subjects to Filter Chapters
                </div>
                <Select
                  isMulti
                  options={subjectOptions}
                  value={subjectOptions.filter((option) =>
                    selectedSubjects.includes(option.value)
                  )}
                  onChange={(selectedOptions) => {
                    const selectedIds = selectedOptions.map(
                      (option) => option.value
                    );
                    setSelectedSubjects(selectedIds);
                  }}
                  styles={customSelectStyles}
                  menuPortalTarget={document.body}
                  placeholder="Select subjects..."
                  noOptionsMessage={() => "No subjects available"}
                />
              </div>

             
            </div>
          </div>

          {/* Chapters Table Section */}
          {chapters.length > 0 && (
            <div style={{
              background: "#fff",
              borderRadius: "12px",
              overflow: "hidden",
              boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
              marginTop: "16px"
            }}>
              <div style={{
                padding: "20px 24px",
                borderBottom: "1px solid #e5e7eb",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                flexWrap: "wrap",
                gap: "16px"
              }}>
                <div>
                  <h3 style={{
                    fontSize: "18px",
                    fontWeight: "600",
                    color: "#1e293b",
                    margin: 0
                  }}>
                    Available Chapters
                  </h3>
                
                </div>

                <div style={{
                  position: "relative",
                  width: "280px"
                }}>
                  <div style={{
                    position: "absolute",
                    left: "12px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    color: "#94a3b8",
                    zIndex: 1
                  }}>
                    <MagnifyingGlass size={20} />
                  </div>
                  <input
                    type="text"
                    placeholder="Search chapters..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    style={{
                      padding: "10px 20px 10px 44px",
                      borderRadius: "10px",
                      border: "1px solid #e2e8f0",
                      fontSize: "14px",
                      width: "100%",
                      outline: "none",
                      transition: "all 0.2s",
                      background: "#fff",
                      boxShadow: "0 1px 2px rgba(0,0,0,0.05)"
                    }}
                  />
                </div>
              </div>

              <div style={{ overflowX: "auto" }}>
                <table style={{
                  width: "100%",
                  borderCollapse: "collapse",
                  minWidth: "600px"
                }}>
                  <thead style={{
                    background: "#f8fafc",
                    borderBottom: "2px solid #e5e7eb"
                  }}>
                    <tr>
                      <th style={{
                        padding: "16px",
                        textAlign: "center",
                        fontSize: "13px",
                        fontWeight: "700",
                        color: "#475569",
                        textTransform: "uppercase",
                        letterSpacing: "0.4px",
                        width: "80px"
                      }}>
                        #
                      </th>
                      <th style={{
                        padding: "16px",
                        textAlign: "left",
                        fontSize: "13px",
                        fontWeight: "700",
                        color: "#475569",
                        textTransform: "uppercase",
                        letterSpacing: "0.4px"
                      }}>
                        Chapter Name
                      </th>
                      <th style={{
                        padding: "16px",
                        textAlign: "center",
                        fontSize: "13px",
                        fontWeight: "700",
                        color: "#475569",
                        textTransform: "uppercase",
                        letterSpacing: "0.4px",
                        width: "150px"
                      }}>
                        <div style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: "8px",
                          cursor: "pointer"
                        }} onClick={handleSelectAll}>
                          <div style={{
                            width: "18px",
                            height: "18px",
                            border: "2px solid #94a3b8",
                            borderRadius: "4px",
                            backgroundColor: allSelected ? "#3E80F9" : "transparent",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            transition: "all 0.2s"
                          }}>
                            {allSelected && (
                              <CheckCircle size={12} color="#fff" weight="bold" />
                            )}
                          </div>
                          <span>Select All</span>
                        </div>
                      </th>
                    </tr>
                  </thead>

                  {dataLoading ? (
                    <TableLoader />
                  ) : (
                    <tbody>
                      {filteredChapters.length === 0 ? (
                        <tr>
                          <td colSpan={3} style={{ padding: "40px", textAlign: "center" }}>
                            <div style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              gap: "12px",
                              color: "#94a3b8"
                            }}>
                              <div style={{
                                fontSize: "36px",
                                background: "#f1f5f9",
                                width: "60px",
                                height: "60px",
                                borderRadius: "50%",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center"
                              }}>
                                📚
                              </div>
                              <div style={{ fontSize: "16px", fontWeight: "600", color: "#475569" }}>
                                No chapters found
                              </div>
                              <div style={{ fontSize: "13px", maxWidth: "300px" }}>
                                {searchTerm ? "Try adjusting your search term" : "Select subjects and fetch chapters"}
                              </div>
                            </div>
                          </td>
                        </tr>
                      ) : (
                        filteredChapters.map((chapter, index) => (
                          <tr 
                            key={chapter.id} 
                            style={{
                              borderBottom: "1px solid #f1f5f9",
                              transition: "background 0.2s",
                              cursor: "pointer"
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.background = "#f8fafc";
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.background = "#fff";
                            }}
                            onClick={() => handleChapterChange(chapter.id)}
                          >
                            <td style={{
                              padding: "16px",
                              textAlign: "center",
                              fontSize: "14px",
                              fontWeight: "600",
                              color: "#475569"
                            }}>
                              <div style={{
                                width: "28px",
                                height: "28px",
                                borderRadius: "6px",
                                background: "#f1f5f9",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                margin: "0 auto"
                              }}>
                                {chapter.serial}
                              </div>
                            </td>
                            
                            <td style={{ padding: "16px" }}>
                              <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                                <div style={{
                                  fontSize: "15px",
                                  fontWeight: "500",
                                  color: "#1e293b"
                                }}>
                                  {chapter.chapterName}
                                </div>
                                
                              </div>
                            </td>
                            
                            <td style={{ padding: "16px", textAlign: "center" }}>
                              <div 
                                style={{
                                  width: "20px",
                                  height: "20px",
                                  border: "2px solid #94a3b8",
                                  borderRadius: "4px",
                                  backgroundColor: chapter.selected ? "#3E80F9" : "transparent",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  margin: "0 auto",
                                  cursor: "pointer",
                                  transition: "all 0.2s"
                                }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleChapterChange(chapter.id);
                                }}
                              >
                                {chapter.selected && (
                                  <CheckCircle size={12} color="#fff" weight="bold" />
                                )}
                              </div>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  )}
                </table>
              </div>

              {/* Action Buttons */}
              {filteredChapters.length > 0 && (
                <div style={{
                  padding: "24px",
                  borderTop: "1px solid #e5e7eb",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "16px"
                }}>
                  <button
                    onClick={handleSubmit}
                    style={{
                      background: "linear-gradient(135deg, #10b981 0%, #059669 100%)",
                      color: "#fff",
                      border: "none",
                      padding: "12px 32px",
                      borderRadius: "10px",
                      fontSize: "14px",
                      fontWeight: "600",
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      transition: "all 0.3s",
                      boxShadow: "0 2px 8px rgba(16, 185, 129, 0.3)"
                    }}
                    onMouseEnter={(e) => e.target.style.transform = "translateY(-2px)"}
                    onMouseLeave={(e) => e.target.style.transform = "translateY(0)"}
                  >
                    <CheckCircle size={18} />
                    Submit Selected Chapters
                  </button>
                  
                  <button
                    onClick={() => navigate(`/pick-questions/${id}`)}
                    style={{
                      background: "#f1f5f9",
                      color: "#475569",
                      border: "none",
                      padding: "12px 32px",
                      borderRadius: "10px",
                      fontSize: "14px",
                      fontWeight: "600",
                      cursor: "pointer",
                      transition: "all 0.3s"
                    }}
                    onMouseEnter={(e) => e.target.style.background = "#e2e8f0"}
                    onMouseLeave={(e) => e.target.style.background = "#f1f5f9"}
                  >
                    Skip for Now
                  </button>
                </div>
              )}
            </div>
          )}

          {/* Empty State */}
          {!isLoading && chapters.length === 0 && !dataLoading && (
            <div style={{
              background: "#fff",
              borderRadius: "12px",
              padding: "60px 20px",
              textAlign: "center",
              marginTop: "24px",
              boxShadow: "0 1px 3px rgba(0,0,0,0.08)"
            }}>
              <div style={{
                fontSize: "48px",
                marginBottom: "16px",
                color: "#cbd5e1"
              }}>
                📚
              </div>
              <h3 style={{
                fontSize: "20px",
                fontWeight: "600",
                color: "#334155",
                marginBottom: "8px"
              }}>
                No Chapters Available
              </h3>
              <p style={{
                fontSize: "14px",
                color: "#64748b",
                maxWidth: "400px",
                margin: "0 auto 24px"
              }}>
                Select subjects and fetch chapters to get started. Chapters will appear here once you select subjects.
              </p>
              <div style={{
                padding: "16px",
                background: "#f8fafc",
                borderRadius: "8px",
                maxWidth: "400px",
                margin: "0 auto",
                fontSize: "13px",
                color: "#475569"
              }}>
                <div style={{ fontWeight: "600", marginBottom: "4px" }}>💡 Tip:</div>
                Select at least one subject from the filter section above and click "Fetch Chapters"
              </div>
            </div>
          )}
        </>
      )}

      <style>
        {`
          @keyframes pulse {
            0%, 100% { opacity: 1; }
            50% { opacity: 0.5; }
          }
          
          *:focus {
            outline: 2px solid #3E80F9;
            outline-offset: 2px;
          }
          
          button:hover:not(:disabled) {
            transform: translateY(-2px);
          }
          
          input:hover, select:hover {
            border-color: #94a3b8 !important;
          }
          
          input:focus, select:focus {
            border-color: #3E80F9 !important;
            box-shadow: 0 0 0 3px rgba(62, 128, 249, 0.1) !important;
          }
        `}
      </style>
    </div>
  );
};

export default ChapterList;